<!-- <div class="px-10 py-5 border-t border-slate-300 dark:border-slate-100/[0.2] flex justify-between"> -->
<div class="w-full px-10 py-5 border-t border-slate-300 dark:border-slate-100/[0.2] flex justify-between">
    @if(_orderWizardNavigationService.activeStep()>0) {
        <button 
            class="px-5 py-2 text-sm rounded-md bg-secondary-600 dark:bg-secondary-500 text-white disabled:opacity-40 hover:bg-secondary-500 transition"
            (click)="_orderWizardNavigationService.prevStep()" 
            [disabled]="_orderWizardNavigationService.activeStep() === 0 || _orderWizardService.loading$()">
            <!--i18n: Back-->
            {{ 'i18n.app.features.pages.order.wizard.common.footer.button_01' | translate }}
        </button>
    }
    @else {<div></div>}
    
    @if(_orderWizardNavigationService.activeStep()==5) {
        <order-wizard-save-and-pay></order-wizard-save-and-pay>
    }
    @else {
        <button 
            [disabled]= "isNextDisabled()"
            class="px-5 py-2 text-sm rounded-md bg-secondary-600 dark:bg-secondary-500
             text-white disabled:opacity-40 hover:bg-secondary-500  
             transition"
            (click)="_orderWizardNavigationService.nextStep()">
            <!--i18n: Back-->
            {{ 'i18n.app.features.pages.order.wizard.common.footer.button_02' | translate }}
        </button>
    }
</div>




<!-- 
<div [formGroup]="form!">


   @if(_orderWizardService.currentStep === 0){
     <div [formGroupName]="_orderWizardService.modelNames.step01.key">
        <order-wizard-pickup-point></order-wizard-pickup-point>

    </div>
   }


   @if(_orderWizardService.currentStep === 1){
    <div [formGroupName]="_orderWizardService.modelNames.step02.key">
        
    </div>
   }

 
   @if(_orderWizardService.currentStep === 2){
    <div formGroupName="step3">
        <app-radio-item formControlName="riskLevel"></app-radio-item>
    </div>
   }
  

</div> -->